import { FC } from "react";

import { LogoBrand } from "../../assets";



const FooterText: FC = (): JSX.Element => {
  return (
      <div className="mt-3 container-fluid">
        <div className="row">
          <div className="col-md-2 text-center text-md-end mb-2 mb-md-0">
            <img className="img-fluid" alt="EUFLEXXA" src={LogoBrand} style={{width:'180px'}}/>
          </div>
          <div className="col-md-10">
            <p className="text-justify">
              This site is intended for US health care professionals. SUPARTZ FX is a trademark of Seikagaku Corp.
              Bioventus, the Bioventus logo, DUROLANE, GELSYN-3 are registered trademarks of Bioventus LLC.
              All other trademarks are property of their respective owners. ©2018 Bioventus LLC
            </p>
          </div>
        </div>
      </div>
  )
};

export default FooterText;
